import React, { useState } from 'react'
import _, { isEmpty, isNull } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload, Select } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import axios from 'axios'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'

const SubEquipmentCategoryForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState("")
  const [categories, setCategories] = useState([])

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        category: formData.category.id,
      })
      setImageUrl(formData.image)
    }
    fetchCategories()
    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/category/allCategory`
      )
      setCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          categoryId: values.category,
        }
        if (values.image) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.image.file)) {
              formImgData.append('image', await compressFile(values.image.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/equipment/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.img = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        } else {
          data.img = formData.image
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id,
            data.categoryId = formData.category.id
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
      title='Edit Sub category'
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="รูปหน้าปก">
          <Row type="flex" justify="center">
            <Col>
              {getFieldDecorator(`image`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="img"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img src={imageUrl} alt="img" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Sub Category Name">
          {getFieldDecorator(`name`, {
          })(<Input
            name="name"
            placeholder="Sub Category Name" />)}
        </Form.Item>
        <Form.Item label="กลุ่มวัสดุ">
          {getFieldDecorator(`category`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกกลุ่มวัสดุ"
              name="categoryId"
            >
              {categories.map(category => (
                <Select.Option key={category.id} value={category.id} disabled={!_.isEmpty(formData)}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {`${!_.isEmpty(formData) ? 'Save ' : 'Create'}`}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedSubEquipmentCategoryForm = Form.create({ name: 'SubEquipmentCategoryForm' })(
  SubEquipmentCategoryForm
)
export default WrappedSubEquipmentCategoryForm